import React from 'react';
import { Backdrop, CircularProgress, Modal } from '@material-ui/core/';

const Blocker = ({ open }) => {
	return (
		<Modal open={open || false}>
			<Backdrop style={{ zIndex: 1501 }} open={open || false}>
				<CircularProgress color="secondary" />
			</Backdrop>
		</Modal>
	);
};

export default Blocker;
